import request from '@/utils/request'

export function getMemberShipYearList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetMemberShipYearList.json',
    method: 'get',
    params
  })
}

export function addMemberShipYear(username, password) {
  const data = {
    username: username,
    password: password
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddMemberShipYear.json',
    method: 'post',
    data
  })
}

export function updateOldDataMode(mode) {
  const data = {
    mode: mode
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateOldDataMode.json',
    method: 'post',
    data
  })
}

export function updateMemberShipYear(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateMembershipYearSettings.json',
    method: 'post',
    data
  })
}

export function deleteMemberShipYear(year) {
  const data = {
    year: year
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/DeleteMemberShipYear.json',
    method: 'post',
    data
  })
}

//
export function updateMemberShipType(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateMemberShipType.json',
    method: 'post',
    data
  })
}

export function getMemberShipTypeList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetMemberShipTypeList.json',
    method: 'get',
    params
  })
}

/* admin user */
export function getAdminUserList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetAdminUserList.json',
    method: 'post',
    params
  })
}

export function addAdminUser(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddAdminUser.json',
    method: 'post',
    data
  })
}

export function updateAdminUser(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateAdminUser.json',
    method: 'post',
    data
  })
}

export function deleteAdminUser(userId) {
  const data = {
    userId: userId
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/DeleteAdminUser.json',
    method: 'post',
    data
  })
}

export function getAdminUser(userId) {
  const params = {
    id: userId
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetAdminUser.json',
    method: 'get',
    params
  })
}

/* role manager */
export function getRoleList(params) {
  params = params || {}
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetRoleList.json',
    method: 'get',
    params
  })
}

export function addRole(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddRole.json',
    method: 'post',
    data
  })
}

export function updateRole(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateRole.json',
    method: 'post',
    data
  })
}

export function deleteRole(roleId) {
  const data = {
    id: roleId
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/DeleteRole.json',
    method: 'post',
    data
  })
}

export function getRoleById(id) {
  const params = {
    id: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetMyRole.json',
    method: 'get',
    params
  })
}

export function getPrivilegeList() {
  const params = {
    tree: 1
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPriviligeList.json',
    method: 'get',
    params
  })
}

/* fees manager */
export function getFeesList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetMemberShipTypeList.json',
    method: 'get',
    params
  })
}

export function updateFees(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateMemberShipType.json',
    method: 'post',
    data
  })
}

/* protocol manager */
export function getAgreementList() {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetAgreementList.json',
    method: 'get'
  })
}

export function getAgreementById(id) {
  const params = {
    id: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetAgreementDetail.json',
    method: 'get',
    params
  })
}

export function updateAgreement(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateAgreement.json',
    method: 'post',
    data
  })
}

/* qiniu token */
export function getQiniuUploadToken() {
  const params = {
    deadline: 3600,
    scope: process.env.QINIU_SCOPE,
    strict: true
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetQiniuUploadToken.json',
    method: 'get',
    params
  })
}

/* 学校管理 */
export function getSchoolList(params) {
  if (!params) {
    params = {
      pageSize: 9999
    }
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetSchoolList.json',
    method: 'get',
    params
  })
}

export function addSchool(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddSchool.json',
    method: 'get',
    params
  })
}

export function updateSchool(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateSchool.json',
    method: 'post',
    data
  })
}

export function deleteSchool(id) {
  const data = {
    id: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/DeleteSchool.json',
    method: 'post',
    data
  })
}

export function getSourceList() {
  return ['通过协会微信公众号、微博、官网，渠道', '从别人那里听说的，渠道', '去冰场滑冰时看到有人打冰球', '其他渠道']
}
